import { SMLRouteNames, SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { SMLSectionTab } from '../../components/SMLSectionTabs/SMLSectionTabs';
import { smlSectionTabMessages } from '../../navigation/smlNavigationMessages';

/**
 * The tabs of Posts (design navigation-v2 c, variant B): Board and Calendar. The Calendar tab
 * carries the red count of the posts that failed to publish (it was the Calendar menu badge). The
 * Composer is a page under Posts, not a tab.
 */
export function postsTabs(screen: SMLRouteNames | undefined, failedCount: number | undefined): SMLSectionTab[] {
  return [
    {
      id: 'board',
      label: smlSectionTabMessages.postsBoard,
      route: SMLRoutes.promotePosts,
      active: screen === SMLRouteNames.promotePosts,
    },
    {
      id: 'calendar',
      label: smlSectionTabMessages.postsCalendar,
      route: SMLRoutes.promoteCalendar,
      active: screen === SMLRouteNames.promoteCalendar,
      badge: failedCount !== undefined && failedCount > 0 ? failedCount : undefined,
    },
  ];
}
